import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import About from './pages/About';
import Blog from './pages/Blog';
import CaseStudies from './pages/CaseStudies';
import Contact from './pages/Contact';
import CredentialMonetization from './pages/CredentialMonetization';
import DigitalEcosystem from './pages/DigitalEcosystem';
import Documentation from './pages/Documentation';
import DocumintWallet from './pages/DocumintWallet';
import Documint from './pages/DocumintID';
import FAQ from './pages/FAQ';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import IDWallet from './pages/IDWallet';
import IssueCredentials from './pages/IssueCredentials';
import LogoEditor from './pages/LogoEditor';
import MDLVerification from './pages/MDLVerification';
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import TechPlatform from './pages/TechPlatform';
import PlatformOverview from './pages/PlatformOverview';
import IndiaDPI from './pages/IndiaDPI';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/docs" element={<Documentation />} />
              <Route path="/tech-platform" element={<TechPlatform />} />
              <Route path="/platform-overview" element={<PlatformOverview />} />
              <Route path="/issue-credentials" element={<IssueCredentials />} />
              <Route path="/id-wallet" element={<IDWallet />} />
              <Route path="/digital-ecosystem" element={<DigitalEcosystem />} />
              <Route
                path="/credential-monetization"
                element={<CredentialMonetization />}
              />
              <Route path="/mdl-verification" element={<MDLVerification />} />
              <Route path="/documint-wallet" element={<DocumintWallet />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/documint-id" element={<Documint />} />
              <Route path="/india-dpi" element={<IndiaDPI />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/support" element={<Support />} />
              <Route path="/logo" element={<LogoEditor />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
